import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  addJob,
  deleteJob,
  editJob,
  getJobs,
  getJob
} from "./jobAPI";

const initialState = {
  jobs: [],
  isLoading: false,
  isError: false,
  error: "",
  editing: {},
};

// async thunks
export const fetchJobs = createAsyncThunk(
  "job/fetchJobs",
  async () => {
    const jobs = await getJobs();
    return jobs;
  }
);

export const createJob = createAsyncThunk(
  "job/createJob",
  async (data) => {
    const job = await addJob(data);
    return job;
  }
);

export const changeJob = createAsyncThunk(
  "job/changeJob",
  async ({ id, data }) => {
    const job = await editJob(id, data);
    return job;
  }
);

export const removeJob = createAsyncThunk(
  "job/removeJob",
  async (id) => {
    const job = await deleteJob(id);
    return job;
  }
);

export const fetchJob = createAsyncThunk(
  "job/fetchJob",
  async (id) => {
    const { data } = await getJob(id);
    return data;
  }
);

// create slice
const jobSlice = createSlice({
  name: "job",
  initialState,
  reducers: {
    editInActive: (state) => {
      state.editing = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobs.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchJobs.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.jobs = action.payload;
      })
      .addCase(fetchJobs.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
        state.jobs = [];
      })
      .addCase(createJob.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(createJob.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.jobs.push(action.payload);
      })
      .addCase(createJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(changeJob.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(changeJob.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.editing = {};

        const indexToUpdate = state.jobs.findIndex(
          (t) => t.id === action.payload.id
        );

        state.jobs[indexToUpdate] = action.payload;
      })
      .addCase(changeJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(removeJob.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(removeJob.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;

        state.jobs = state.jobs.filter(
          (t) => t.id !== action.meta.arg
        );
      })
      .addCase(removeJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(fetchJob.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchJob.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.editing = action.payload;
      })
      .addCase(fetchJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
        state.editing = {};
      })
  },
});

export default jobSlice.reducer;
export const { editInActive } = jobSlice.actions;
